import * as Partial from "../Partial/index.js";
import * as Specular$dInternal$dIncremental$dGlobal from "../Specular.Internal.Incremental.Global/index.js";
import * as Specular$dInternal$dIncremental$dMutableArray from "../Specular.Internal.Incremental.MutableArray/index.js";
import * as Specular$dInternal$dIncremental$dOptional from "../Specular.Internal.Incremental.Optional/index.js";
import * as Specular$dInternal$dIncremental$dRef from "../Specular.Internal.Incremental.Ref/index.js";
import * as Specular$dInternal$dProfiling from "../Specular.Internal.Profiling/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unsafe$dReference from "../Unsafe.Reference/index.js";
import {
  _new,
  get_adjustedHeight,
  get_changedAt,
  get_dependents,
  get_height,
  get_name,
  get_observers,
  get_source,
  get_value,
  set_adjustedHeight,
  set_changedAt,
  set_height,
  set_name,
  set_value
} from "./foreign.js";
const valueExc = node => {
  const value_opt = get_value(node);
  return !Unsafe$dReference.reallyUnsafeRefEq(value_opt)(Specular$dInternal$dIncremental$dOptional.none) ? value_opt : Partial._crashWith("Optional.fromSome: none");
};
const toSomeNodeArray = Unsafe$dCoerce.unsafeCoerce;
const toSomeNode = Unsafe$dCoerce.unsafeCoerce;
const refcount = node => {
  const observers = get_observers(node);
  const numDependents = Specular$dInternal$dIncremental$dMutableArray.length(observers);
  const dependents = get_dependents(node);
  const numObservers = Specular$dInternal$dIncremental$dMutableArray.length(dependents);
  return numDependents + numObservers | 0;
};
const name = node => get_name(node);
const isChangingInCurrentStabilization = node => {
  const currentStabilizationNum = Specular$dInternal$dIncremental$dRef.read(Specular$dInternal$dIncremental$dGlobal.globalCurrentStabilizationNum);
  const changedAt = get_changedAt(node);
  return changedAt === currentStabilizationNum;
};
const create = source => {
  const dependents = Specular$dInternal$dIncremental$dMutableArray.empty();
  const observers = Specular$dInternal$dIncremental$dMutableArray.empty();
  return _new(Specular$dInternal$dIncremental$dOptional.none, source, dependents, observers, Specular$dInternal$dIncremental$dOptional.none, 0);
};
const annotate = Specular$dInternal$dProfiling.enabled ? set_name : (v, v1) => {};
export {annotate, create, isChangingInCurrentStabilization, name, refcount, toSomeNode, toSomeNodeArray, valueExc};
export * from "./foreign.js";
